import { render, staticRenderFns } from "./CooperationPartners.vue?vue&type=template&id=26dcdb91"
import script from "./CooperationPartners.vue?vue&type=script&lang=js"
export * from "./CooperationPartners.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports